import React from 'react';
import { confirmable, createConfirmation } from 'react-confirm';
import BasicButton from 'components/BasicButton';
import BasicButtonGroup from 'components/BasicButtonGroup';
import Dialog from 'scenes/Dialog';
import Popup from 'components/Popup';
import UxHelpers from 'helpers/ux-helpers.js';

const PushProcessDialog = props => {
  const { type, determine = 'this', show, proceed, dismiss, cancel } = props;

  const onSuccess = () => {
    proceed(true);
    UxHelpers.overflowLock('unlock');
  };

  const onCancel = () => {
    proceed(false);
    UxHelpers.overflowLock('unlock');
  };

  const cancelHandler = () => {
    cancel();
    UxHelpers.overflowLock('unlock');
  };

  const buttons = (
    <BasicButtonGroup
      groupStyles={{
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <BasicButton
        controlFunc={onSuccess}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText="Push and Send Emails"
      />
      <BasicButton
        controlFunc={onCancel}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText="Push and Don't Send Emails"
      />
      <BasicButton
        controlFunc={cancelHandler}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText="Cancel"
      />
    </BasicButtonGroup>
  );

  const body = (
    <Dialog>
      <div style={{ width: '100%', textAlign: 'center' }}>
        Would you like to Push {determine} {type} and send an Application email
        to new candidates?
      </div>
    </Dialog>
  );

  return (
    show && (
      <Popup
        actions={{
          dismiss,
          cancel,
        }}
        dismissWhenClose={false}
        buttonsRender={buttons}
        bodyRender={body}
      />
    )
  );
};

export default createConfirmation(confirmable(PushProcessDialog));
